

















import { mapState } from "vuex";
import sizable from "../../mixins/sizable";

export default {
  mixins: [sizable],
  data() {
    return {
      minColumnSize: 200,
      minColumnCount: 2,
    };
  },
  computed: {
    ...mapState(["loadingCounter"]),
    mainStyle() {
      const contW = this.width;
      let numCols = Math.floor(contW / this.minColumnSize);
      numCols = Math.max(numCols, this.minColumnCount);
      const columnWidth = contW / numCols;
      const headerHeight = 0;
      return {
        "--column-width": `${columnWidth}px`,
        "--header-height": `${headerHeight}px`,
      };
    },
  },
  mounted() {
    this.setTheme("dark");
  },
  methods: {
    setTheme(name) {
      if (!name) {
        return;
      }
      const htmlEL = document.querySelector("html");
      if (!htmlEL) {
        return;
      }
      htmlEL.setAttribute("data-theme", name);
    },
  },
};
